import { Transform } from "silver";
import { BookControl } from "core/Controls/Books/BookControl";
import { BookControlService, TeacherBookControlService } from "core/Services/BookControlService";
import { BookBandService } from "core/Services/BookBandService";
import { ControlBand } from "core/Controls/ControlBand";
import { ContextualPopup } from "shared/Components/ContextualPopup";
import { RecommendedLang } from "Lang/Pages/Library";

interface BookBandControlItem {
	control: BookControl;
	element: HTMLElement;
}

export class BookBand {

	private controlBand: ControlBand<BookBandControlItem>;
	private bandEndpoint?: string;

	constructor(
		title: string,
		bookIds: number[],
		bandType: number,
		transform: Transform,
		private bookControlService: BookControlService,
		private bookBandService: BookBandService
	) {
		this.controlBand = new ControlBand<BookBandControlItem>(
			{
				getControls: (...bookIdsToFetch: number[]): BookBandControlItem[] => {
					const controls: BookBandControlItem[] = [];
					for (let i = 0; i < bookIdsToFetch.length; i++) {
						const control = this.bookControlService.makeBookControl(bookIdsToFetch[i], undefined, bandType);
						controls.push({
							control,
							element: control.element
						});
					}
					return controls;
				}
			},
			transform,
			(bookControlService instanceof TeacherBookControlService ? "-adminBookBand" : "-studentBookBand"),
			6
		);
		this.controlBand.setTitle(title);
		this.controlBand.onRemoveItem(({ control }) => {
			control.control.unset();
		});
		this.controlBand.onSelectedOptionChange(({ value }) => {
			const endpoint = this.bandEndpoint;
			if (endpoint === undefined) {
				return;
			}
			const promise = this.bookBandService.getBandBookIds(endpoint, value);
			this.controlBand.setSourceDataAsync(promise).catch(console.error);
		});
		this.controlBand.setSourceData(bookIds);
	}

	public setDynamicBand(bandEndpoint: string, options: { [ value: string ]: string }, selectedOption?: string): void {
		this.bandEndpoint = bandEndpoint;
		this.controlBand.setOptions(options, selectedOption);
	}

	public setLang(lang: RecommendedLang): void {
		this.controlBand.setNextButtonLabel(lang.ALT_NEXT_BATCH());
		this.controlBand.setEmptyMessage(lang.TELL_MORE_RECOMMENDED());
	}

	public setContextualPopup(popup: ContextualPopup): void {
		this.controlBand.setContextualPopup(popup);
	}

	public get element(): HTMLElement {
		return this.controlBand.element;
	}

	public handleResize(): void {
		this.controlBand.handleResize();
	}
}
